import { CARE_DIRECTORY_ROLE_KEYS } from "./roles";

/**
 * Where to send someone after sign-in (and what the brand mark opens).
 *
 * Super admins keep the fleet dashboard. Care staff and doctors land on
 * /patients — the working surface for those roles. Patient/family accounts
 * have no portal home yet, so they still fall through to /dashboard.
 */
export function defaultLoginPath(roles: readonly string[]): string {
  if (roles.includes("super_admin")) return "/dashboard";
  if (
    roles.includes("doctor") ||
    roles.some((role) => (CARE_DIRECTORY_ROLE_KEYS as readonly string[]).includes(role))
  ) {
    return "/patients";
  }
  return "/dashboard";
}

export function safeNextPath(next: string | null, fallback = "/dashboard"): string {
  if (
    next &&
    /^\/(?![/\\])/.test(next) &&
    !/[\x00-\x1f\\]/.test(next)
  ) {
    return next;
  }
  return fallback;
}
